import { DefaultValues, FieldValues, Resolver, useForm } from "react-hook-form";

export const useRegisterForm = <TFormData extends FieldValues>(
  resolver: Resolver<TFormData>,
  defaultValues: DefaultValues<TFormData>,
) => {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<TFormData>({
    resolver,
    defaultValues,
    mode: "onBlur",
    reValidateMode: "onBlur",
  });

  return {
    control,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    errors,
  };
};
